import Vue from "vue";
import Vuex from "vuex";
import {
  saveToken,
  getToken,
  removeToken,
  saveUserName,
  getUserName,
  saveFirstEntryValue,
} from "@/utils/auth";
import { fetchEcpAuth } from "@/api/auth";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    user: getUserName(),
    token: getToken(),
    isLoading: false,
    isUserFetched: false,
  },
  mutations: {
    SET_USER(state, user) {
      console.log(user);
      state.user = user;
      saveUserName(user.user.name);
      saveFirstEntryValue(user.first_entry);
    },
    SET_TOKEN(state, token) {
      state.token = token;
      saveToken(token);
    },
    LOGOUT(state) {
      state.user = null;
      state.token = "";
      removeToken();
    },
    SET_LOADING(state, val) {
      state.isLoading = val;
    },
  },
  actions: {
    async login({ commit }, { password, p12 }) {
      try {
        const response = await fetchEcpAuth({ password, p12 });
        if (response.data.token) {
          commit("SET_TOKEN", response.data.token);
          commit("SET_USER", response.data);
          return { success: true };
        }
        return false;
      } catch (error) {
        const message =
          error?.response?.data?.message || "Ошибка при авторизации";
        commit("LOGOUT");
        return { success: false, message };
      }
    },

    // logout({ commit }) {
    //   commit("LOGOUT");
    // },
  },
  getters: {
    isAuthenticated: (state) => !!state.token,
    user: (state) => state.user,
    isLoading: (state) => state.isLoading,
  },
};
